import { render } from "./BusinessCardList.vue?vue&type=template&id=1dbb20f8"
import script from "./BusinessCardList.vue?vue&type=script&lang=js"
export * from "./BusinessCardList.vue?vue&type=script&lang=js"

import "./BusinessCardList.vue?vue&type=style&index=0&id=1dbb20f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__